import { refreshFooter } from "./src/components/Layout/Riotbar";
export { wrapPageElement, wrapRootElement } from "./src/wrapElement";

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (!prevLocation || location === prevLocation) {
    return; // prevLocation is null on first renders
  }
  refreshFooter();
};
